import { HttpClient } from './httpClient'
import * as ApiEvents from './apiEvents'

export const getFormData = (shipmentId,cancelToken) => {
  
  //HttpClient.cancelRequest()
  const data = {
    eventMessage: shipmentId,
    eventType: ApiEvents.GET_FORM_CDS,
    eventTime: Date.now(),
  }
  return HttpClient.custom({
    data,
    cancelToken
  })
}

export const getEvent = (eventMessage) => ({
  eventType: ApiEvents.GET_FORM_CDS,
  eventTime: Date.now(),
  eventMessage,
})
export const getDataCDS = () => {
  let dataSent = getEvent(window.shipmentId)
  return dataSent
}

export const getDropdownValues = (shipmentType,cancelToken) => {
  const data = {
    eventMessage:
     { countryCode: 'uk',
        "shipmentType":shipmentType
     
     },
    eventType: ApiEvents.GET_DROPDOWN_VALUES_EU,
    eventTime: Date.now(),
  }
  return HttpClient.custom({
    data,
    cancelToken
  })
}

export const getsearchcDropdownValuesUK = (dropdownType, searchFilter,shipmentType) => {
  const data = {
    eventMessage: {
      dropdownType: dropdownType,
      searchText: searchFilter,
      countryCode: 'uk',
      shipmentType:shipmentType
    },
    eventType: ApiEvents.SEARCH_DROPDOWN_VALUES_EU,
    eventTime: Date.now(),
  }
  return HttpClient.custom({
    data,
  })
}

export const getShipmentNotes = (shipmentId) => {
  const data = {
    eventMessage: {
      shipmentId,
    },
    eventType: ApiEvents.GET_SHIPMENT_NOTES,
    eventTime: Date.now(),
  }

  return HttpClient.custom({
    data,
  })
}

//  for save dafferedpayment for parties tab

export const saveDafferedPayment = (param) => {
  const data = {
    eventMessage: {
      shipmentId: window.shipmentId,
      parties: {
        ...param,
      },
    },
    eventType: ApiEvents.SAVE_FORM_CDS,
    eventTime: Date.now(),
  }

  return HttpClient.custom({
    data,
  })
}

export const getSearchDropdownValues = (payload) => {
  const { eventType, searchFilter, entityType = 'PORT', condition, type } = payload
  const data = {
    eventMessage: {
      condition: condition,
      countryOfDestination: 'GB',
      entityType: entityType,
      searchValue: searchFilter
    },
    eventType: eventType,
    eventTime: Date.now(),
  }
  if(type){ 
    data.eventMessage.type = type; 
  }
  return HttpClient.custom({
    data,
  })
}


export const refreshIntialData = (shipmentId) =>{

console.log('refreshIntialData is called!!')
  const data = {
    eventMessage:shipmentId,
    eventType:ApiEvents.INITIALIZE_CDS_FORM,
    eventTime: Date.now(),
  }

  return HttpClient.custom({
    data,
  })
}

export const refreshTariffData = (shipmentId) => {
  const data = {
    eventMessage: shipmentId,
    eventType: ApiEvents.REFRESH_TARIFF_API,
    eventTime: Date.now(),
  }

  return HttpClient.custom({
    data,
  })
}

  export const downloadCDSdocuments = (shipmentId) =>{

    console.log('API GET_GENERATED_PDF_URL_CDS_DMS_TAX is called!!')
    const data = {
      eventMessage: {
        shipmentId,
         },
      eventType: ApiEvents.GET_GENERATED_PDF_URL_CDS_DMS_TAX,
      eventTime: Date.now(),
    }
  
    return HttpClient.custom({
      data,
    })
  }

  export const sendToBilling = (shipmentId) =>{

    const data = {
      eventMessage: {
        id: shipmentId
         },
      eventType: ApiEvents.INVC_SEND_TO_BILLING,
      eventTime: Date.now(),
    }
  
    return HttpClient.custom({
      data,
    })
  }